import type {
  IJobAssociatedTaskTemplate,
  ITaskTemplateSection,
  IDocument
} from '@/interfaces'
import type { JobType } from '@/enum'
import TaskTemplateSection from '../task-templates/TaskTemplateSection'
import DocumentModel from '../DocumentModel'
import Base from '../Base'

class JobAssociatedTaskTemplate extends Base implements IJobAssociatedTaskTemplate {
  taskTemplateId: string
  title: string
  description: string
  type: JobType
  employeesCount: number
  sections: ITaskTemplateSection[]
  documents: IDocument[]

  constructor(taskTemplate?: any) {
    super(taskTemplate)
    this.taskTemplateId = taskTemplate?.taskTemplateId
    this.title = taskTemplate?.title ?? ''
    this.description = taskTemplate?.description ?? ''
    this.type = taskTemplate?.type
    this.employeesCount = taskTemplate?.employeesCount ?? 1
    this.sections = taskTemplate?.sections?.map(
      (section: any) => new TaskTemplateSection(section, true)
    ) ?? []
    this.documents = taskTemplate?.documents?.map((document: any) => new DocumentModel(document)) ?? []
  }
}

export default JobAssociatedTaskTemplate
